// extracted by mini-css-extract-plugin
export default {"link":"TextLink_link__Mwkmd","muted":"TextLink_muted__P8klO"};